import { useMemo } from 'react';
import { 
  Home,
  MessageSquare,
  MessageCircle,
  FileText,
  Shield,
  HelpCircle,
  Settings
} from 'lucide-react';
import { useNotifications } from './useNotifications';
import { sidebarTranslations } from '../translations/sidebar';
import type { User } from '../types/user';

export function useNavigation(user: User | null) {
  const { unreadCount } = useNotifications();
  const userLanguage = user?.preferredLanguage?.toLowerCase() || 'fr';
  const t = sidebarTranslations[userLanguage];

  const navigationItems = useMemo(() => {
    const items = [
      { 
        path: '/', 
        name: t.dashboard.name,
        icon: Home,
        description: t.dashboard.description
      },
      { 
        path: '/forum', 
        name: t.forum.name,
        icon: MessageSquare,
        description: t.forum.description
      },
      { 
        path: '/messages', 
        name: t.messages.name,
        icon: MessageCircle,
        description: t.messages.description,
        badge: unreadCount > 0 ? unreadCount : null
      },
      { 
        path: '/documents', 
        name: t.documents.name,
        icon: FileText,
        description: t.documents.description
      },
      { 
        path: '/council', 
        name: t.council.name,
        icon: Shield,
        description: t.council.description
      },
      { 
        path: '/assistance', 
        name: t.assistance.name,
        icon: HelpCircle,
        description: t.assistance.description
      },
      { 
        path: '/my-posts', 
        name: t.myPosts.name,
        icon: FileText,
        description: t.myPosts.description
      }
    ];

    // Add admin link for both admin and council members
    if (user?.role === 'admin' || user?.role === 'council') {
      items.push({
        path: '/admin/discussion',
        name: t.admin.name,
        icon: Settings,
        description: t.admin.description
      });
    }

    return items;
  }, [user?.role, unreadCount, t]);

  return { navigationItems, t };
}